// Zero is the unbounded city feed. Numeric choices are strict venue distances.
export const DEFAULT_EVENT_DISCOVERY_RADIUS_KM = 0;
export const EVENT_DISCOVERY_RADIUS_OPTIONS_KM = [0, 5, 20, 50];
export const MIN_EVENT_DISCOVERY_RADIUS_KM = 5;
export const MAX_EVENT_DISCOVERY_RADIUS_KM = 200;

export const normalizeEventDiscoveryRadiusKm = (
  value,
  fallback = DEFAULT_EVENT_DISCOVERY_RADIUS_KM
) => {
  const parsed = Number.parseInt(String(value ?? ""), 10);
  const fallbackValue = Number.parseInt(String(fallback ?? ""), 10);
  const resolved = Number.isFinite(parsed)
    ? parsed
    : Number.isFinite(fallbackValue)
      ? fallbackValue
      : DEFAULT_EVENT_DISCOVERY_RADIUS_KM;
  if (resolved === 0) return 0;
  return Math.min(
    MAX_EVENT_DISCOVERY_RADIUS_KM,
    Math.max(MIN_EVENT_DISCOVERY_RADIUS_KM, resolved)
  );
};

export const normalizeOptionalEventDiscoveryRadiusKm = (
  value,
  fallback = DEFAULT_EVENT_DISCOVERY_RADIUS_KM
) => {
  if (value === null || value === false || String(value ?? "").trim() === "0") {
    return null;
  }
  const normalized = normalizeEventDiscoveryRadiusKm(value, fallback);
  return normalized === 0 ? null : normalized;
};

export const getEventDiscoveryRadiusQueryValue = (value) =>
  normalizeOptionalEventDiscoveryRadiusKm(value) ?? 0;

export const getEventDiscoveryLocationParams = (value) => ({
  radius_km: getEventDiscoveryRadiusQueryValue(value),
  // radius_km=0 + include_nearby=1 means the city feed; the legacy API call
  // without include_nearby continues to mean an exact-city lookup.
  include_nearby: 1,
});
